import { ApolloError } from '@apollo/client';
import { GraphQLFormattedError } from 'graphql';

// Narrows an unknown catch value to the first GraphQL error on it, if any. Callers read
// .extensions.errorClass (api/src/libs/errorClassification.ts's ErrorClass) and any other
// extensions field off the result themselves.
export function firstGraphQLError(err: unknown): GraphQLFormattedError | undefined {
  return err instanceof ApolloError ? err.graphQLErrors[0] : undefined;
}
